import { call, put, takeEvery, select } from 'redux-saga/effects';
import { clientMutation } from 'config/helpers/GraphQLApi';
import { endpoints } from 'config/constants';
import { ExceptionManager } from 'config/helpers/Logging';
import { ShowErrorNotification } from 'config/helpers/Utils';

import {
    CERTIFICATES_GENERATE_TOKEN,
    CERTIFICATES_DOWNLOAD
} from './actionTypes';

import {
    certificatesGenerateTokenResult,
    certificatesDownload,
    certificatesSetLoading
} from './actions';

function* certificatesGenerateTokenRequest(action) {
    try {
        yield put(certificatesSetLoading(true));
        
        // Mapear tipos de certificado
        const typeMap = {
            'peace': 'pazysalvo',
            'debt': 'deuda', 
            'current': 'aldia',
            'tax': 'tributario'
        };
        
        const certificateType = typeMap[action.payload] || action.payload;
        
        // Generar PDF directamente
        const query = `
            mutation {
                generateCertificatePDF(certificateType: "${certificateType}") {
                    success
                    message
                    pdfBase64
                }
            }
        `;
        
        const response = yield call(clientMutation, query, {}, endpoints.GRAPHQL_GENERAL);
        
        if (response.generateCertificatePDF.success) {
            // Descargar PDF desde base64
            const pdfBase64 = response.generateCertificatePDF.pdfBase64;
            let nombre = '';
            switch (action.payload) {
                case 'tax': 
                    nombre = 'tributario';
                    break;
                case 'current': 
                    nombre = 'al_dia';
                    break;
                case 'peace': 
                    nombre = 'paz_y_salvo';
                    break;
                case 'debt': 
                    nombre = 'de_deuda';
                    break;
                default:
                    break;
            }
            // Crear enlace de descarga directamente con data URI
            const dataUri = `data:application/pdf;base64,${pdfBase64}`;
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = dataUri;
            a.download = `certificado_${nombre}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            
        } else {
            ShowErrorNotification(response.generateCertificatePDF.message);
        }
        
        yield put(certificatesSetLoading(false));
        
    } catch (error) {
        ExceptionManager(error, 'certificates', 'certificatesGenerateTokenRequest');
        ShowErrorNotification('Error al generar certificado');
        yield put(certificatesSetLoading(false));
    }
}

function* certificatesDownloadRequest(action) {
    try {
        const { token, certificateType } = action.payload;
        const user = yield select(state => state.authRedux.user);
        
        let url = '';
        switch (certificateType) {
            case 'peace':
                url = `http://localhost:44358/GenerarPazYSalvo/${user.documentNumber}`;
                break;
            case 'debt':
                url = `http://localhost:44358/GenerarCertificadoDeuda/${user.documentNumber}`;
                break;
            case 'current':
                url = `http://localhost:44358/GenerarCertificadoAlDia/${user.documentNumber}`;
                break;
            case 'tax':
                url = `http://localhost:44358/GenerarCertificadoTributario/${user.documentNumber}`;
                break;
            default:
                throw new Error('Tipo de certificado no válido');
        }
        
        // Abrir certificado en nueva ventana con token
        const fullUrl = `${url}?token=${token}`;
        window.open(fullUrl, '_blank');
        
        yield put(certificatesSetLoading(false));
        
    } catch (error) {
        ExceptionManager(error, 'certificates', 'certificatesDownloadRequest');
        ShowErrorNotification('Error al descargar certificado');
        yield put(certificatesSetLoading(false));
    }
}

export default function* certificatesSagas() {
    yield takeEvery(CERTIFICATES_GENERATE_TOKEN, certificatesGenerateTokenRequest);
    yield takeEvery(CERTIFICATES_DOWNLOAD, certificatesDownloadRequest);
}